var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body column"},[_c('Toolbar'),_vm._v(" "),_c('div',{staticClass:"holiday_notice"},[_vm._v("Your custom order will take a couple of weeks as it's crafted just for you.")]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"page"},[_c('nuxt')],1)]),_vm._v(" "),_c('Housekeeping')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }